import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Row, Col, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
// import { postHead } from '../../reducers/BusinessReducer';
import { usePersistedStore } from '../../store/persisted-store';
import { schemaValidator } from '../../utils/validator';

export default function SeoForm({ head, businessToken, onSubmit }) {
    const { postHead, business } = usePersistedStore()
    const loading = business.businesses.loading;
    const [form] = Form.useForm()
    const [tooltipOpen, setTooltipOpen] = useState(false);

    let selectedId;
    if (head)
        selectedId = head.id;

    const selectItems = [{ id: 1, value: null, title: "مقدار پیش فرض" },
    { id: 3, value: 0, title: "NoFollow" },
    { id: 2, value: 1, title: "Follow" },
    ];

    const selected_item = selectItems?.find(item => item.value == head?.followStatus);
    const sampleSchema = [{
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "AboutPage",
                "@id": "https://bimeh.com/about#aboutpage",
                "url": "https://bimeh.com/about",
                "name": "درباره بیمه دات کام",
                "inLanguage": "fa",
                "description": "صفحه درباره بیمه دات کام",
            }
        ]
    }, {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "بیمه دات کام",
                "item": "https://bimeh.com"
            }]
    }];

    function onFinish(values) {
        const validate = (values.url).split("/");
        const len = validate.length;
        if (validate.length > 1 && (validate[len - 1].length || values.url === '/')) {
            const params = {
                url: values.url,
                title: values.title,
                description: values.description,
                metaTags: values.metaTags,
                canonical: values.canonical,
                Schema: values.Schema,
                id: selectedId ? selectedId : null,
                followStatus: (typeof values.follow === "undefined") ? selected_item?.value : values.follow,
            };
            const type = selectedId ? 'edit' : 'post';
            postHead({ params, type, businessToken, cb: onSubmit })
        }
    };

    useEffect(() => {
        if (head) {
            form.setFieldsValue(head);
        };
    }, [form, head])

    return (
        <>
            {tooltipOpen && (
                <div
                    aria-hidden="true"
                    onClick={() => setTooltipOpen(false)}
                    className="tooltip-backdrop"
                />
            )}

            <Form
                labelCol={{
                    span: 24,
                }}
                wrapperCol={{
                    span: 24,
                }}
                form={form}
                name="add_seo"
                onFinish={onFinish}>
                <Row gutter={[8]}>
                    <Col lg={24} xs={24}>
                        <Form.Item
                            label="آدرس صفحه"
                            name="url"
                            rules={[{ required: true, message: 'لطفا آدرس صفحه را وارد کنید' }]}>
                            <Input
                                // disabled={head.url ? true: false}
                                placeholder="آدرس صفحه"
                                size="large" />
                        </Form.Item>
                    </Col>
                    <Col lg={24} xs={24}>
                        <Form.Item
                            label="عنوان صفحه"
                            name="title"
                            rules={[{ required: true, message: 'لطفا عنوان صفحه را وارد کنید' }]}>
                            <Input
                                placeholder="عنوان صفحه"
                                size="large" />
                        </Form.Item>
                    </Col>
                    <Col lg={12} xs={24}>
                        <Form.Item
                            label="کنونیکال "
                            name="canonical">
                            <Input.TextArea
                                rows={1}
                                placeholder="کنونیکال " />
                        </Form.Item>
                    </Col>
                    <Col lg={12} xs={24}>
                        <Form.Item
                            label="فالو شدن لینک"
                            name="follow">

                            <Select
                                defaultValue={{
                                    value: selected_item?.value,
                                    label: selected_item?.title,
                                }}
                            >
                                {selectItems.map(selected => {
                                    return (
                                        <Select.Option key={selected.id} value={selected.value}>
                                            {selected.title}
                                        </Select.Option>
                                    )
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="توضیحات" name="description"
                            rules={[{ required: true, message: 'لطفا توضیحات صفحه را وارد کنید' }]}>
                            <Input.TextArea
                                rows={2}
                                placeholder="توضیحات" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="متا تگ ها"
                            name="metaTags">
                            <Input.TextArea
                                rows={2}
                                placeholder="</ 'meta name='robots' id='followStatus'  content='noindex , nofollow >" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label={
                                <div className="form-label-wrapper">
                                    <span>اسکیما</span>

                                    <Tooltip
                                        open={tooltipOpen}
                                        onOpenChange={setTooltipOpen}
                                        trigger="click"
                                        placement="left"
                                        color="#fff"
                                        overlayClassName="tooltip-content"
                                        title={
                                            <div>
                                                {JSON.stringify(sampleSchema, null, 2)}
                                            </div>
                                        }
                                    >
                                        <QuestionCircleOutlined className="form-tooltip-icon" />
                                    </Tooltip>
                                </div>
                            }
                            name="Schema"
                            validateTrigger="onSubmit"
                            rules={[
                                {
                                    validator: schemaValidator,
                                },
                            ]}
                        >
                            <Input.TextArea rows={6} className='ltr-text' />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item>
                            <button disabled={loading} type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit" style={{ width: "100%" }}>
                                <i className={`${loading ? "bx bx-loader bx-spin" : "bx bx-check-double"} "font-size-14 align-middle mr-2 ml-3"`}></i>ثبت
                            </button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </>
    )
}
